<div class="mb-5">
    <app-header [title]="'complete payment'" [showProgressBar]="false"></app-header>
</div>
<div class="d-xl-flex align-items-start justify-content-between">
    <div class="flex-grow-1">
        <form name="form" [formGroup]="form">
            <div class="row">
                <div class="col-12 mb-4" *ngIf="wallet">
                    <div class="bloc-title mb-3">My Wallet</div>
                    <div class="bg-gray-200 p-3 br-15">
                        <div class="d-flex align-items-center justify-content-between mb-4">
                            <mat-checkbox
                                checked="true"
                                [disableRipple]="true"
                                class="mr-4 montserrat-regular"
                                (click)="$event.preventDefault()"
                                >Use my wallet</mat-checkbox
                            >
                            <h5 class="montserrat-semi-bold text-gray-500" *ngIf="wallet">
                                USD
                                {{ (wallet?.amount ? wallet.amount : 0) | number: '1.2-2' }}
                            </h5>
                        </div>
                        <div class="d-flex align-items-center justify-content-between">
                            <img
                                src="./assets/images/wallet-big.svg"
                                style="width: 100px !important; height: 100px !important"
                                alt="Wallet"
                                title="Wallet"
                                class="mr-4"
                            />
                            <div class="flex-grow-1">
                                <div class="d-flex align-items-center mb-3">
                                    <span>I would like to use USD</span>
                                    <mat-form-field class="form-group dark-input col-5 mx-3">
                                        <input
                                            matInput
                                            formControlName="wallet_amount"
                                            type="number"
                                            placeholder="Amount"
                                            disabled
                                        />
                                    </mat-form-field>
                                    <span>from my wallet.</span>
                                </div>
                                <div
                                    class="d-flex align-items-center justify-content-between"
                                    style="justify-content: flex-end !important"
                                ></div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-12 mb-4">
                    <div class="bloc-title mb-3">
                        Billing address
                        <mat-checkbox
                            formControlName="saveBillingAddressDetails"
                            class="ml-4 montserrat-regular"
                            value="saveBillingAddressDetails"
                            >Save Details For Later</mat-checkbox
                        >
                    </div>

                    <div class="bg-gray-200 p-3 br-15">
                        <div class="row">
                            <div class="col-6 mb-4">
                                <mat-form-field class="form-group dark-input">
                                    <input
                                        matInput
                                        formControlName="firstName"
                                        type="text"
                                        placeholder="First Name"
                                    />
                                </mat-form-field>
                            </div>
                            <div class="col-6 mb-4">
                                <mat-form-field class="form-group dark-input">
                                    <input
                                        matInput
                                        formControlName="lastName"
                                        type="text"
                                        placeholder="Last Name"
                                    />
                                </mat-form-field>
                            </div>
                            <div class="col-6 mb-4">
                                <mat-form-field class="form-group dark-input">
                                    <mat-label>Country</mat-label>
                                    <mat-select
                                        formControlName="country"
                                        panelClass="select-panel-down"
                                        [disableOptionCentering]="true"
                                    >
                                        <mat-option
                                            *ngFor="let country of countries"
                                            [value]="country.label"
                                            class="text-capitalize"
                                        >
                                            {{ country.label }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-6 mb-4">
                                <mat-form-field class="form-group dark-input">
                                    <input
                                        matInput
                                        formControlName="city"
                                        type="text"
                                        placeholder="City"
                                    />
                                </mat-form-field>
                            </div>
                            <div class="col-6 mb-4">
                                <mat-form-field class="form-group dark-input">
                                    <input
                                        matInput
                                        formControlName="street"
                                        type="text"
                                        placeholder="Street"
                                    />
                                </mat-form-field>
                            </div>
                            <div class="col-6 mb-4">
                                <mat-form-field class="form-group dark-input">
                                    <input
                                        matInput
                                        formControlName="building"
                                        type="text"
                                        placeholder="Building"
                                    />
                                </mat-form-field>
                            </div>
                            <div class="col-6">
                                <mat-form-field class="form-group dark-input">
                                    <input
                                        matInput
                                        formControlName="postalCode"
                                        type="text"
                                        placeholder="Postal Code"
                                    />
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
    <div class="col-12 col-xl-3">
        <div class="bloc-title mb-3">Summary</div>
        <div *ngIf="editMode" class="bg-gray-200 br-15 py-3">
            <div *ngIf="!previewMode" class="d-flex justify-content-between px-3 mb-3">
                <span class="montserrat-semi-bold">Updated Campaign fees</span>
                <h6
                    class="montserrat-semi-bold text-gray-500"
                    *ngIf="newCheckOutInfo && newCheckOutInfo?.totalPrice"
                >
                    {{
                        newCheckOutInfo?.totalPrice.value
                            | currency: newCheckOutInfo?.totalPrice.currencyCode
                    }}
                </h6>
            </div>
            <div class="d-flex justify-content-between px-3 mb-3">
                <span *ngIf="previewMode" class="montserrat-semi-bold">
                    Additional Municipality fees</span
                >
                <span *ngIf="!previewMode" class="montserrat-semi-bold">
                    Updated Municipality fees</span
                >
                <h6 class="montserrat-semi-bold text-gray-500" *ngIf="newCheckOutInfo">
                    {{
                        (newCheckOutInfo?.municipalityFees
                            ? newCheckOutInfo?.municipalityFees.value
                            : 0
                        ) | currency: newCheckOutInfo?.municipalityFees.currencyCode
                    }}
                </h6>
            </div>
            <div class="d-flex justify-content-between px-3">
                <span
                    class="montserrat-semi-bold"
                    *ngIf="newCheckOutInfo?.vatPercentage != null"
                >
                    VAT ({{ newCheckOutInfo?.vatPercentage }}%)
                </span>

                <h6
                    class="montserrat-semi-bold text-gray-500"
                    *ngIf="newCheckOutInfo?.vatAmount != null && newCheckOutInfo?.totalPrice"
                >
                    {{
                        newCheckOutInfo?.vatAmount
                            | currency: newCheckOutInfo?.totalPrice.currencyCode
                    }}
                </h6>
            </div>
            <hr class="bg-gray-500" />
            <div class="px-3">
                <div class="text-gray mb-3">Payment Method</div>
                <div class="d-flex justify-content-between mb-3">
                    <span class="montserrat-semi-bold">Wallet</span>
                    <h6 class="montserrat-semi-bold text-gray-500">
                        {{
                            newCheckOutInfo?.totalPriceWithVat.value
                                | currency: newCheckOutInfo?.totalPriceWithVat.currencyCode
                        }}
                    </h6>
                </div>
            </div>
            <div
                class="bg-gray-500 br-15 d-flex align-items-center justify-content-between m-3 mx-3 p-3"
            >
                <h6 class="montserrat-bold text-white text-uppercase">
                    {{
                        newCheckOutInfo && newCheckOutInfo?.totalPriceWithVat.value >= 0
                            ? 'total'
                            : 'refund'
                    }}
                </h6>
                <h5
                    class="montserrat-bold text-white"
                    *ngIf="newCheckOutInfo && newCheckOutInfo?.totalPriceWithVat"
                >
                    {{
                        abs(newCheckOutInfo?.totalPriceWithVat.value)
                            | currency: newCheckOutInfo?.totalPriceWithVat.currencyCode
                    }}
                </h5>
            </div>
            <div>
                <div class="text-center">
                    <button
                        class="btn btn-lg btn-gray-500"
                        [disabled]="disableCheckout()"
                        (click)="checkoutNow()"
                    >
                        checkout
                    </button>
                </div>
            </div>
        </div>
        <div class="bg-gray-200 br-15 py-3 mt-5">
            <div class="d-flex justify-content-between px-3 mb-3">
                <span class="montserrat-semi-bold">Campaign fees</span>
                <h6
                    class="montserrat-semi-bold text-gray-500"
                    *ngIf="checkoutInfo && checkoutInfo?.totalPrice"
                >
                    {{
                        checkoutInfo?.totalPrice.value
                            | currency: checkoutInfo?.totalPrice.currencyCode
                    }}
                </h6>
            </div>
            <div class="d-flex justify-content-between px-3 mb-3">
                <span class="montserrat-semi-bold">Municipality fees</span>
                <h6 class="montserrat-semi-bold text-gray-500" *ngIf="checkoutInfo">
                    {{
                        (checkoutInfo?.municipalityFees ? checkoutInfo?.municipalityFees.value : 0)
                            | currency: checkoutInfo?.municipalityFees.currencyCode
                    }}
                </h6>
            </div>
            <div class="d-flex justify-content-between px-3">
                <span
                    class="montserrat-semi-bold"
                    *ngIf="checkoutInfo && checkoutInfo?.vatPercentage"
                    >VAT ({{ checkoutInfo?.vatPercentage }}%)</span
                >
                <h6
                    class="montserrat-semi-bold text-gray-500"
                    *ngIf="checkoutInfo && checkoutInfo?.vatAmount && checkoutInfo.totalPrice"
                >
                    {{
                        checkoutInfo?.vatAmount
                            | currency: checkoutInfo?.totalPrice.currencyCode
                    }}
                </h6>
            </div>
            <hr class="bg-gray-500" />
            <div *ngIf="!editMode" class="px-3">
                <div class="text-gray mb-3">Payment Method</div>
                <div class="d-flex justify-content-between mb-3">
                    <span class="montserrat-semi-bold">Wallet</span>
                    <h6 class="montserrat-semi-bold text-gray-500">
                        {{
                            checkoutInfo?.totalPriceWithVat.value
                                | currency: checkoutInfo?.totalPriceWithVat.currencyCode
                        }}
                    </h6>
                </div>
            </div>
            <div
                class="bg-gray-500 br-15 d-flex align-items-center justify-content-between m-3 mx-3 p-3"
            >
                <h6 *ngIf="!editMode" class="montserrat-bold text-white text-uppercase">
                    {{
                        checkoutInfo && checkoutInfo.totalPriceWithVat.value > 0
                            ? 'total'
                            : 'refund'
                    }}
                </h6>
                <h6 *ngIf="editMode" class="montserrat-bold text-white text-uppercase">
                    already paid
                </h6>
                <h5
                    class="montserrat-bold text-white"
                    *ngIf="checkoutInfo && checkoutInfo?.totalPriceWithVat"
                >
                    {{
                        abs(checkoutInfo?.totalPriceWithVat.value)
                            | currency: checkoutInfo?.totalPriceWithVat.currencyCode
                    }}
                </h5>
            </div>
            <div *ngIf="!editMode">
                <div class="text-center">
                    <button
                        class="btn btn-lg btn-gray-500"
                        [disabled]="disableCheckout()"
                        (click)="checkoutNow()"
                    >
                        checkout
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
